import { Grid, Typography, TextField, Button } from '@mui/material'
import React, { useState } from 'react'
import { CourierService } from '../../../interfaces/Courier'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { PriorizationDDL } from '../priorizationddl'

interface CreateCourierServiceProps {
  courierId: number
  getServices: () => void
  notify: (message: string, status: boolean) => void
}

const postCourierService = (
  courierId: number,
  dto: Partial<CourierService>
) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}/service`)

  return axios.post(url.toString(), dto)
}

export const CreateCourierService: React.FC<CreateCourierServiceProps> = ({
  courierId,
  getServices,
  notify
}) => {
  const [newServiceState, setNewServiceState] = useState({
    name: '',
    active: false,
    typePriorityId: -1
  })

  const { state, callApi } = useApi()

  const requestCreateCourierService = () => {
    callApi(postCourierService(courierId, newServiceState))
      .then(() => notify('Servicio creado exitosamente.', true))
      .catch((error) => alert(error))
      .finally(getServices)
  }

  const handleNewServiceStateChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target
    setNewServiceState((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const isNewServiceButtonDisabled =
    newServiceState.name.trim().length === 0 || state.status === Status.Loading

  return (
    <Grid container spacing={2} direction={'row'}>
      <Grid item xs={12} key={999999}>
        <Typography>Nuevo Servicio</Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <TextField
          fullWidth
          variant='outlined'
          disabled={state.status === Status.Loading}
          value={newServiceState.name}
          onChange={handleNewServiceStateChange}
          label='Nombre de Servicio'
          name='name'
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <PriorizationDDL
          onChange={handleNewServiceStateChange}
          value={newServiceState.typePriorityId}
          disabled={state.status === Status.Loading}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Button
          fullWidth
          variant='contained'
          color='primary'
          onClick={requestCreateCourierService}
          disabled={isNewServiceButtonDisabled}
        >
          Crear Servicio
        </Button>
      </Grid>
    </Grid>
  )
}
